import { Form, message, Modal } from "antd";
import { Rule } from "antd/lib/form";
import { partnerApi } from "api/partner.api";
import { AppButton, AppInput } from "components/antd-ui";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Partner } from "types/partner";

const rules: Rule[] = [{ required: true }];

interface PartnerModalProps {
  visible: boolean;
  status: ModalStatus;
  partner: Partial<Partner>;
  onClose: () => void;
  onSubmitOk: () => void;
}

export const PartnerModal = ({
  visible,
  status,
  partner,
  onClose,
  onSubmitOk,
}: PartnerModalProps) => {
  const [form] = Form.useForm<Partner>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status === "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    form.setFieldsValue({ ...partner });
  }, [partner]);

  const handleSubmit = async () => {
    await form.validateFields();

    setLoading(true);
    try {
      if (status === "create") {
        const data = { partner: form.getFieldsValue() };
        await partnerApi.create(data);
        message.success("Tạo đối tác thành công");
      } else {
        const data = { partner: form.getFieldsValue(true) };
        await partnerApi.update(data.partner.id || 0, data);
        message.success("Cập nhật đối tác thành công");
      }

      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      style={{ top: 15 }}
      onCancel={onClose}
      open={visible}
      title={
        <h1 className="text-xl font-bold text-center">
          {status === "create" ? "Tạo mới đối tác" : "Cập nhật đối tác"}
        </h1>
      }
      footer={null}
      width={700}
      className="app-form-modal"
    >
      <div className="app-form-modal__body">
        <section className="app-form-modal__section">
          <Form layout="vertical" form={form}>
            <Form.Item label="Tên" name="name" rules={rules}>
              <AppInput placeholder="Nhập tên đối tác" />
            </Form.Item>

            <Form.Item shouldUpdate={true}>
              {() => (
                <Form.Item label="Logo" name="logo">
                  <SingleImageUpload
                    onUploadOk={(path: string) => {
                      form.setFieldsValue({ logo: path });
                    }}
                    imageUrl={form.getFieldValue("logo")}
                    uploadUrl={
                      import.meta.env.VITE_API_URL + "/v1/shop/product/upload"
                    }
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Form>
        </section>
      </div>
      <div className="ant-modal-footer">
        <div className="flex gap-2 justify-end">
          <AppButton onClick={onClose}>Hủy</AppButton>
          <AppButton tone="primary" loading={loading} onClick={handleSubmit}>
            {status === "create" ? "Xác nhận" : "Cập nhật"}
          </AppButton>
        </div>
      </div>
    </Modal>
  );
};
